export default __webpack_public_path__ + "static/media/mallory_mp_compact_book.aff168e8.ttf";